import React, { Component } from 'react';
import b64toBlob from 'b64-to-blob';
import RothButton from '../components/RothButton.js';
//import RothTextInput from '../components/RothTextInput.js';
import FontAwesome from 'react-fontawesome';

import img_logoRed from '../img/logo_red.png';
import FileSaver from 'file-saver';
import ReactModal from 'react-modal';

export default class DonePage extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalOk = this.handleModalOk.bind(this);
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }
  handleModalOk() {
    this.setState({ showModal: false });
  }

  style = {};
  sendRoth = () => {
    this.props.sendRoth();
  };
  openPDF = () => {
    var blob = b64toBlob(this.props.response.pdf, 'application/pdf');
    var fileURL = URL.createObjectURL(blob);
    var win = window.open('', 'RothQuickCalcPDF');
    win.document.write('<title>' + this.props.response.offerCode + ' ' + this.props.projectName + '.pdf</title>');
    win.document.write(
      '<style>body {margin:0px}</style><iframe src="' +
        fileURL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    );
  };
  downloadPDF = () => {
    var blob = b64toBlob(this.props.response.pdf, 'application/pdf');
    FileSaver.saveAs(blob, this.props.response.offerCode + ' ' + this.props.projectName + '.pdf');
  };
  downloadExcel = () => {
    var blob = b64toBlob(this.props.response.excel, 'application/vnd.ms-excel');
    FileSaver.saveAs(blob, this.props.response.offerCode + ' ' + this.props.projectName + '.xls');
  };
  componentWillMount = () => {
    console.log('SendData');
    this.props.sendData('print');
  };

  render = () => (
    <div className="content">
      <div className="inner">
        <div>
          <div style={{ textAlign: 'right', padding: '20px' }}>
            <img style={{ height: '64px' }} src={img_logoRed} alt={img_logoRed} />
          </div>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ fontSize: '30px', textAlign: 'left', margin: '10px 30px 10px 30px' }}>{this.props.text('done', 'h1')}</h1>
            <h2 style={{ fontSize: '20px', textAlign: 'left', margin: '10px 30px 70px 30px' }}>{this.props.text('done', 'desc')}</h2>
            <div style={{ width: '70%', marginLeft: 'auto', marginRight: 'auto' }}>
              {this.props.response.responseStatus === '' || this.props.response.responseStatus === 'waiting' ? (
                <div>
                  <FontAwesome name={'spinner fa-pulse fa-3x fa-fw'} />
                  <h2 style={{ fontSize: '20px', textAlign: 'center', margin: '30px 30px 30px 30px' }}>
                    {this.props.text('done', 'waiting')}
                  </h2>
                </div>
              ) : (
                <div>
                  {/*<RothButton type = "white" fn = {(v) => (0)} value = "" disabled = {this.props.response.pdf === ""}>{this.props.text("done", "b1")}</RothButton>*/}
                  <RothButton
                    type="white"
                    fn={() => {
                      this.sendRoth();
                      this.handleOpenModal();
                    }}
                    value=""
                    disabled={this.props.response.pdf === '' || this.props.response.sentToRoth}
                  >
                    {this.props.text('done', 'b2')}
                  </RothButton>
                  {/*<RothButton type = "white" fn = {this.openPDF} value = {"done"} disabled = {this.props.response.pdf === ""} style = {{display:!pdfSupport() ? "none" : "block"}}>{this.props.text("done", "b3")}</RothButton>*/}
                  <RothButton type="white" fn={this.downloadPDF} value={'done'} disabled={this.props.response.pdf === ''}>
                    {this.props.text('done', 'b5')}
                  </RothButton>
                  <RothButton type="white" fn={this.downloadExcel} value={'done'} disabled={this.props.response.excel === ''}>
                    {this.props.text('done', 'b6')}
                  </RothButton>
                  <br />
                  <br />
                </div>
              )}
            </div>
          </div>
        </div>
        <div>
          <RothButton type="wide" style={{ marginTop: '10px', marginBottom: '10px' }} fn={this.props.startNewProject}>
            {this.props.text('done', 'newEstimate')}
          </RothButton>
          <RothButton type="wide" style={{ marginTop: '10px', marginBottom: '10px' }} fn={this.props.logout}>
            {this.props.text('done', 'logout')}
          </RothButton>
        </div>
      </div>
      <ReactModal
        isOpen={this.state.showModal}
        contentLabel=""
        style={{
          content: {
            position: 'absolute',
            top: '30%',
            width: 'calc(100% - 80px)',
            marginLeft: 'auto',
            marginRight: 'auto',
            height: '400px',
            border: '0px solid white',
            backgroundColor: this.props.constants.colorRed,
            borderRadius: '22px',
            padding: '40px 10px',
            maxWidth: '500px',
          },
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>
            {this.props.text('done', 'sentToRoth')}
          </div>
          <div style={{ textAlign: 'center' }}>
            <RothButton type="halfWhite" fn={this.handleModalOk}>
              {this.props.text('done', 'ok')}
            </RothButton>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/DonePage.js
 **/